import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Megaphone, X, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api/anuncios/activos';

const BotonAnuncio = ({ a }) => {
  const cls = 'inline-flex items-center gap-1 rounded-full bg-primary px-4 py-1.5 text-sm font-semibold text-white hover:bg-primary/90 transition-colors whitespace-nowrap';
  const inner = <>{a.texto_boton} <ArrowRight className="h-4 w-4" /></>;
  if (a.link.startsWith('/')) return <Link to={a.link} className={cls} data-testid={`anuncio-boton-${a.id}`}>{inner}</Link>;
  return <a href={a.link} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`anuncio-boton-${a.id}`}>{inner}</a>;
};

export const AnunciosBanner = () => {
  const [items, setItems] = useState([]);
  const [cerrados, setCerrados] = useState([]);

  useEffect(() => {
    axios.get(API).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);

  const visibles = items.filter((a) => !cerrados.includes(a.id));
  if (!visibles.length) return null;
  return (
    <div className="max-w-5xl mx-auto mb-8 space-y-3" data-testid="anuncios-banner">
      {visibles.map((a) => (
        <div key={a.id} className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl border border-primary/20 bg-primary/5 px-5 py-4 animate-fade-in"
          data-testid={`anuncio-${a.id}`}>
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <Megaphone className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
            <p className="text-sm sm:text-base text-gray-800 break-words" data-testid={`anuncio-texto-${a.id}`}>{a.texto}</p>
          </div>
          <div className="flex items-center gap-2 self-end sm:self-auto">
            {a.texto_boton && a.link && <BotonAnuncio a={a} />}
            <button onClick={() => setCerrados([...cerrados, a.id])} className="p-1 rounded-full text-gray-400 hover:text-gray-700 hover:bg-white"
              aria-label="Cerrar anuncio" data-testid={`anuncio-cerrar-${a.id}`}>
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
